// Receipt data model for the SaaS billing prototype.
// See plans/saas-billing/01-stripe-billing-foundation.md for canonical types.

import { CurrencyCode } from './subscription.model';

export interface Receipt {
  id: string;
  chargedAt: string;
  amountMinor: number;
  currency: CurrencyCode;
  description: string;                 // "Solo subscription renewal" or "AI credit top-up: 10,000 credits"
  invoiceId: string | null;            // Null for top-ups
  topUpPackId: string | null;          // Null for subscription renewals
}
